import { ITimeZone } from '../ServerApi/types/ITimeZone';

export enum CachingPolicyType {
  INTERVAL_IN_MINUTES = 'interval_in_minutes',
  REPEAT_DAILY = 'repeat_daily',
  REPEAT_WEEKLY = 'repeat_weekly',
  REPEAT_MONTHLY = 'repeat_monthly'
}

export interface IWorkbookDataFreshnessDescription {
  defaultCacheTimeoutInMinutes?: number;
  intervalInMinutes?: number;
  cachingPolicyType?: CachingPolicyType;
  daysStringCsv?: string;
  refreshTimeOfDay?: number;
  timezone?: ITimeZone;
  error?: number;
}

export interface IWorkbookDataFreshnessInfo {
  workbookDataFreshness?: IWorkbookDataFreshnessDescription;
}

